import React from 'react'
import Lab from '../../components/page-content/our-apps/lab'

export const Page = () => {
  return <Lab />
}

export default Page
